import React from "react";
import Card from "./Card";
import ServiceData from "./ServiceData";

const Service = () => {
    return(
        <>
           <section id="service">
               <div className="container my-5">
               <h1 className="text-center mb-5">Our Services</h1>
               <div className="row gy-5">
                        {
                           ServiceData.map((val,ind) =>{
                                return(
                                    <Card
                                        key ={ind}
                                        imgsrc = {val.imgsrc}
                                        title = {val.title}
                                    />
                                )
                           })
                       }
               </div>
           </div>
           </section>
        </>
    );
}

export default Service;